<h1>Hand-Off Settings</h1>
<p>Select which hand-off types are active at this Wegmans Meals 2GO location</p>

<section>
  <h2>In-Store Pickup</h2>
  <mat-slide-toggle
    [(ngModel)]="handoffTypeViewModels.inStore.isAvailable"
    (change)="handoffTypeChangeEvent(handoffTypeViewModels.inStore)"
    >Offered at this location</mat-slide-toggle
  >
  <h3>In-Store Pickup Instructions</h3>
  <mat-form-field class="example-full-width" appearance="fill">
    <textarea
      matInput
      [(ngModel)]="handoffTypeViewModels.inStore.handoffInstructionsBuffer"
      [disabled]="!handoffTypeViewModels.inStore.instructionSaveButton">
        {{ handoffTypeViewModels.inStore.handoffInstructionsBuffer }}
        </textarea>
  </mat-form-field>
  <div class="button-container">
    @if (handoffTypeViewModels.inStore.instructionSaveButton === false) {
      <div class="">
        <button mat-flat-button color="accent" (click)="instructionsToggle(handoffTypeViewModels.inStore)">
          Edit Instructions
        </button>
      </div>
    }
    @if (handoffTypeViewModels.inStore.instructionSaveButton) {
      <div>
        <button mat-flat-button (click)="instructionsToggle(handoffTypeViewModels.inStore)">Cancel</button>
        <button mat-flat-button color="accent" (click)="saveInstructions(handoffTypeViewModels.inStore)">Save</button>
      </div>
    }
  </div>
</section>

<section>
  <h2>Curbside Pickup</h2>
  <mat-slide-toggle
    [(ngModel)]="handoffTypeViewModels.curbside.isAvailable"
    (change)="handoffTypeChangeEvent(handoffTypeViewModels.curbside)"
    >Offered at this location</mat-slide-toggle
  >
  @if (isPlannedHandoffExceptionEnabled()) {
    <div>
      <button
        mat-flat-button
        class="modal-link-button"
        color="secondary"
        (click)="schedulePlannedHandoffExceptionDialog(handoffTypeViewModels.curbside)">
        Schedule a Planned Curbside Outage
      </button>
      <button
        mat-flat-button
        class="modal-link-button"
        color="secondary"
        (click)="viewPlannedHandoffExceptionDialog(handoffTypeViewModels.curbside)">
        View Planned Curbside Outages
      </button>
    </div>
  }

  <h3>Curbside Parking Spots</h3>
  <increment-input
    [(value)]="handoffTypeViewModels.curbside.data"
    [step]="1"
    [min]="1"
    [max]="handoffTypeViewModels.curbside.dataMax"
    unit="spots"
    (changeEvent)="dataStateChange($event, handoffTypeViewModels.curbside, 'data')">
  </increment-input>
  <div class="button-container">
    <div class="">
      <button
        mat-flat-button
        color="accent"
        [disabled]="!handoffTypeViewModels.curbside.dataSaveButton"
        (click)="saveCurbsideData()">
        Save Change
      </button>
    </div>
  </div>
  <h3>Curbside Pickup Instructions</h3>
  <mat-form-field class="example-full-width" appearance="fill">
    <textarea
      matInput
      [(ngModel)]="handoffTypeViewModels.curbside.handoffInstructionsBuffer"
      [disabled]="!handoffTypeViewModels.curbside.instructionSaveButton">
            {{ handoffTypeViewModels.curbside.handoffInstructionsBuffer }}
            </textarea>
  </mat-form-field>
  <div class="button-container">
    @if (!handoffTypeViewModels.curbside.instructionSaveButton) {
      <div class="">
        <button mat-flat-button color="accent" (click)="instructionsToggle(handoffTypeViewModels.curbside)">
          Edit Instructions
        </button>
      </div>
    }
    @if (handoffTypeViewModels.curbside.instructionSaveButton) {
      <div>
        <button mat-flat-button (click)="instructionsToggle(handoffTypeViewModels.curbside)">Cancel</button>
        <button mat-flat-button color="accent" (click)="saveInstructions(handoffTypeViewModels.curbside)">Save</button>
      </div>
    }
  </div>
</section>

<section>
  <h2>Delivery</h2>
  <div>
    <mat-slide-toggle [(ngModel)]="handoffTypeViewModels.delivery.isAvailable" (change)="deliveryToggleEvent()"
      >Offered at this location</mat-slide-toggle
    >
    @if (isPlannedDeliveryException()) {
      <div>
        <button
          mat-flat-button
          class="modal-link-button"
          color="secondary"
          (click)="schedulePlannedHandoffExceptionDialog(handoffTypeViewModels.delivery)">
          Schedule a Planned Delivery Outage
        </button>
        <button
          mat-flat-button
          class="modal-link-button"
          color="secondary"
          (click)="viewPlannedHandoffExceptionDialog(handoffTypeViewModels.delivery)">
          View Planned Delivery Outages
        </button>
      </div>
    } @else {
      @if (handoffTypeViewModels.delivery.exceptions.length > 0) {
        <div class="temporary-issue">
          <span class="material-symbols-outlined issue-icon">info</span>
          <div class="issue-information">
            <div><b>Temporary Issue reported</b></div>
            <div>
              {{ handoffTypeViewModels.delivery.displayName }} is temporarily <b>off</b> until
              {{ handoffTypeViewModels.delivery.exceptions[0].enableOn | shortDate }}
            </div>
          </div>
        </div>
      }
      <div>
        @if (handoffTypeViewModels.delivery.exceptions.length === 0) {
          <button
            mat-flat-button
            class="modal-link-button"
            color="secondary"
            (click)="temporaryExceptionDialog(handoffTypeViewModels.delivery)">
            Report a Temporary
            {{ handoffTypeViewModels.delivery.displayName }} Issue
          </button>
        }
      </div>
      <div>
        @if (handoffTypeViewModels.delivery.exceptions.length > 0) {
          <button
            mat-flat-button
            class="modal-link-button"
            color="secondary"
            (click)="temporaryExceptionDialog(handoffTypeViewModels.delivery)">
            Remove the Temporary
            {{ handoffTypeViewModels.delivery.displayName }} Issue
          </button>
        }
      </div>
    }

    <app-delivery-map-component
      #deliveryMap
      [saveDisabled]="!handoffTypeViewModels.delivery.dataSaveButton || !authManager.isCurrentAccountAdminOrITRole()"
      [extendedDeliveryAreaEnabled]="handoffTypeViewModels.delivery.extendedDeliveryAreaEnabled"
      (saveButtonClicked)="saveDeliveryData()"
      (deliveryMapChanged)="updateDeliveryMap($event)" />
  </div>
  <h3>Delivery Instructions</h3>
  <mat-form-field class="example-full-width" appearance="fill">
    <textarea
      matInput
      [(ngModel)]="handoffTypeViewModels.delivery.handoffInstructionsBuffer"
      [disabled]="!handoffTypeViewModels.delivery.instructionSaveButton">
                {{ handoffTypeViewModels.delivery.handoffInstructionsBuffer }}
                </textarea>
  </mat-form-field>
  <div class="button-container">
    @if (!handoffTypeViewModels.delivery.instructionSaveButton) {
      <div class="">
        <button mat-flat-button color="accent" (click)="instructionsToggle(handoffTypeViewModels.delivery)">
          Edit Instructions
        </button>
      </div>
    }
    @if (handoffTypeViewModels.delivery.instructionSaveButton) {
      <div>
        <button mat-flat-button (click)="instructionsToggle(handoffTypeViewModels.delivery)">Cancel</button>
        <button mat-flat-button color="accent" (click)="saveInstructions(handoffTypeViewModels.delivery)">Save</button>
      </div>
    }
  </div>
</section>

<section class="tableside">
  <h2>Tableside</h2>
  <div>
    <mat-slide-toggle
      [(ngModel)]="handoffTypeViewModels.tableside.isAvailable"
      (change)="handoffTypeChangeEvent(handoffTypeViewModels.tableside)"
      >Offered at this location</mat-slide-toggle
    >
    @if (tablesideHours.changedState.length === 0 || tablesideHours.changedState === undefined) {
      <h3>Tableside Hours are not available for this store</h3>
    } @else {
      <h3>Business Hours</h3>
      <div>
        <mat-grid-list cols="2" rowHeight="100px">
          @for (day of tablesideHours.changedState; track day) {
            <mat-grid-tile>
              <div class="prep-locations-header-text">{{ day.dayOfWeek | day }}</div>
              <mat-form-field appearance="fill">
                <mat-label>Open</mat-label>
                <mat-select [(value)]="day.openIndex">
                  @for (time of timeRange; track time) {
                    <mat-option
                      [disabled]="!authManager.isCurrentAccountAdminOrITRole()"
                      [value]="time.index"
                      (click)="openTimeSelected(time.time, day.dayOfWeek)">
                      {{ time.time | timeOnly }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="fill">
                <mat-label>Close</mat-label>
                <mat-select [(value)]="day.closeIndex">
                  @for (time of timeRange; track time) {
                    <mat-option
                      [disabled]="!authManager.isCurrentAccountAdminOrITRole()"
                      [value]="time.index"
                      (click)="closeTimeSelected(time.time, day.dayOfWeek)">
                      {{ time.time | timeOnly }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </mat-grid-tile>
          }
        </mat-grid-list>
      </div>
      @if (authManager.doesCurrentAccountHaveAnyRole(["IT", "Admin"])) {
        <div class="button-container">
          <button mat-flat-button class="cancel-button" color="secondary" (click)="cancelHours()">Cancel</button>
          <button
            mat-raised-button
            class="save-button"
            color="accent"
            [disabled]="hoursChanged()"
            (click)="saveHours()">
            Save
          </button>
        </div>
      }
    }
  </div>
</section>
